import Loadable from "react-loadable";
import Spinner from "../../cmp/Spinner";

const QRCodePage = Loadable({
    loader: () => import('./QRCodeInternal'),
    loading: Spinner,
});

export default QRCodePage
